import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[70vh] md:min-h-[80vh] flex items-center justify-center overflow-hidden" data-id="element-196">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-navy" data-id="element-197">
        <img src="https://cdn.magicpatterns.com/uploads/by7ySk3Vwp8eGKKNBRRr96/fOTO_DE_ANGEL_INSURANCE_CON_FONDO_DEL_MAR_PUESTA_DEL_SOL.png" alt="Familia de Tampa al atardecer" className="w-full h-full object-contain md:object-cover object-center" data-id="element-198" />
        <div className="absolute inset-0 bg-navy/80 mix-blend-multiply" data-id="element-199"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-navy/60 via-navy/40 to-navy/90" data-id="element-200"></div>
      </div>

      <div className="container mx-auto px-4 z-10 relative py-20" data-id="element-201">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto text-center text-white" data-id="element-202">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6" data-id="element-203">
            Por Qué la Mayoría de las Personas en Tampa Están a{' '}
            <span className="text-gold" data-id="element-204">
              Un Accidente de la Ruina Financiera
            </span>{' '}
            — Y Ni Siquiera Lo Saben
          </h1>

          <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-205">
            Y Cómo Angel Insurance Le Está Dando a las Familias de Tampa Algo
            Que las Grandes Compañías Nunca Pudieron: Protección Real de
            Personas Reales Que Realmente Se Preocupan
          </p>

          <motion.a href="tel:8134034867" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex items-center justify-center gap-3 bg-gold hover:bg-yellow-500 text-navy font-bold text-lg px-8 py-4 rounded-full shadow-lg transition-all" data-id="element-206">
            <Phone size={24} data-id="element-207" />
            Llámanos Hoy
          </motion.a>
        </motion.div>
      </div>
    </section>;
}